// export const COMETCHAT_CONSTANTS = {
//   APP_ID: "221651f202e583d5",
//   REGION: "eu",
//   AUTH_KEY: "fe58120434fc6dbe5415e75079eb18a2430450a1",
//   IS_STAGING: false,
// };

// export const COMETCHAT_CONSTANTS = {
//   APP_ID: "26580020f03ff346",
//   REGION: "in",
//   AUTH_KEY: "4152b0366478871f0fa8d19a287dd6f5ed5f8eff",
//   IS_STAGING: false,
// };

// export const COMETCHAT_CONSTANTS = {
//   APP_ID: "2422522403fd36e8",
//   REGION: "us",
//   AUTH_KEY: "5a97381b48262090818b4287816f791dbc236731",
//   IS_STAGING: false,
// };

// export const COMETCHAT_CONSTANTS = {
//   APP_ID: "2533973c7fc048be",
//   REGION: "us",
//   AUTH_KEY: "60853ad1d706bb8f94cac8322842adc174245777",
// };

// export const COMETCHAT_CONSTANTS = {
//   APP_ID: "2642663b0062aaa2",
//   REGION: "us",
//   AUTH_KEY: "e262093ee37fb72acb8c9b13ca86304c34fd8213",
// };

// export const COMETCHAT_CONSTANTS = {
//   APP_ID: "2693178751988b98",
//   REGION: "in",
//   AUTH_KEY: "5e64ba711d881f692e05217e17714c596a090f5e",
// };

// export const COMETCHAT_CONSTANTS = {
//   APP_ID: "221651f202e583d5",
//   REGION: "eu",
//   AUTH_KEY: "fe58120434fc6dbe5415e75079eb18a2430450a1",
//   IS_STAGING: false,
// };


// export const COMETCHAT_CONSTANTS = {
//   APP_ID: "221651f202e583d5",
//   REGION: "eu",
//   AUTH_KEY: "fe58120434fc6dbe5415e75079eb18a2430450a1",
//   IS_STAGING: false,
// };

// export const COMETCHAT_CONSTANTS = {
//   APP_ID: "2422522403fd36e8",
//   REGION: "us",
//   AUTH_KEY: "5a97381b48262090818b4287816f791dbc236731",
//   IS_STAGING: false,
// };

// export const COMETCHAT_CONSTANTS = {
//   APP_ID: "221651f202e583d5",
//   REGION: "eu",
//   AUTH_KEY: "fe58120434fc6dbe5415e75079eb18a2430450a1",
//   IS_STAGING: false,
// };

// export const COMETCHAT_CONSTANTS = {
//   APP_ID: "269895ff1bd5541a",
//   REGION: "eu",
//   AUTH_KEY: "8e7013c520a4ecd610d1c5554457114d6fd05592",
//   IS_STAGING: false,
// };

// export const COMETCHAT_CONSTANTS = {
//   APP_ID: "2709994865174007",
//   REGION: "us",
//   AUTH_KEY: "6c530e515867fea837ca9cf3f5314a3814afc564",
//   IS_STAGING: false,
// };


// export const COMETCHAT_CONSTANTS = {
//   APP_ID: "2693178751988b98",
//   REGION: "in",
//   AUTH_KEY: "5e64ba711d881f692e05217e17714c596a090f5e",
//   IS_STAGING: false,
// };


// export const COMETCHAT_CONSTANTS = {
//   APP_ID: "253778b716dc6335",
//   REGION: "us",
//   AUTH_KEY: "eb66838530e31d1e5f68657faf9d4bc31b0cc354",
//   IS_STAGING: true,
// };


// export const COMETCHAT_CONSTANTS = {
//   APP_ID: "26580020f03ff346",
//   REGION: "in",
//   AUTH_KEY: "4152b0366478871f0fa8d19a287dd6f5ed5f8eff",
//   IS_STAGING: false,
// };


// export const COMETCHAT_CONSTANTS = {
//   APP_ID: "27605552540a28b4",
//   REGION: "in",
//   AUTH_KEY: "870f5667c6b7d25f726fd04091e1c04820010237",
//   IS_STAGING: false,
// };

// export const COMETCHAT_CONSTANTS = {
//   APP_ID: "281468e1dc60990c",
//   REGION: "in",
//   AUTH_KEY: "23bf9e9d4fad7deedf4325ed05ecc792450546dd",
//   IS_STAGING: false,
// };

export const COMETCHAT_CONSTANTS = {
  APP_ID: '2547167fe69871fd',
  REGION: 'us',
  AUTH_KEY: '5e1fc8edd290a2f194a6634178eb9db2895391ad',
  IS_STAGING: true,
} as const;
